export default {
  maintenaceSlogan: '¡Volveremos pronto!',
  maintenanceMessage:
    'Actualmente estamos realizando mantenimiento programado para mejorar nuestros servicios para usted. Pedimos disculpas por las molestias y agradecemos su paciencia. Por favor, vuelva más tarde',
  maintenanceAction: 'Necesita ayuda?',
  linkToDiscord: 'Contacta a nuestro equipo de soporte',
}
